import { SvgIcon } from "@material-ui/core";
import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const JobPriorityDBadge = (props: StatusBadgeProps) => {
    const {
        width = "24",
        height = "24",
        viewBox = "0 0 20 20",
        ...rest
    } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="20"
                height="20"
                rx="3"
                fill="#A6D3F4"
                fillOpacity="0.4"
            />
            <path
                d="M7.57815 14H9.83215C12.5346 14 13.9951 12.6085 13.9951 10.0555C13.9951 7.4565 12.4886 5.9845 9.84365 5.9845H7.57815V14ZM8.80865 12.8615V7.123H9.83215C11.8216 7.123 12.7531 8.043 12.7531 10.0095C12.7531 11.9875 11.8216 12.8615 9.71715 12.8615H8.80865Z"
                fill="#21006E"
            />
        </svg>
    );
};
